function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import Popup from '../popup';
import Carousel from '../carousel';
import PinchZoom from '../pinch-zoom';
import ActivityIndicator from '../activity-indicator';
import { isObject, isString } from '../utils/validate';
import LocaleReceiver from '../locale-receiver';
var LoadStatus;

(function (LoadStatus) {
  LoadStatus["before"] = "loadBefore";
  LoadStatus["start"] = "loadStart";
  LoadStatus["end"] = "loadEnd";
  LoadStatus["after"] = "loadAfter";
})(LoadStatus || (LoadStatus = {}));

var formatImages = function formatImages(images) {
  var previewImages = [];
  images.forEach(function (image) {
    if (isString(image)) {
      previewImages.push({
        url: image
      });
    } else if (isObject(image)) {
      previewImages.push({
        url: image.url,
        originUrl: image.originUrl,
        loaded: LoadStatus.before
      });
    }
  });
  return previewImages;
};

var parseState = function parseState(props) {
  var visible = props.visible,
      images = props.images;
  return {
    visible: visible,
    images: formatImages(images)
  };
};

var ImagePreview =
/*#__PURE__*/
function (_Component) {
  _inherits(ImagePreview, _Component);

  function ImagePreview() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ImagePreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ImagePreview)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.doubleClickTimer = void 0;
    _this.touchStartTime = void 0;
    _this.moving = void 0;
    _this.state = parseState(_this.props);

    _this.onChange = function (index) {
      var onChange = _this.props.onChange;

      _this.setState({
        currentIndex: index
      }, function () {
        if (typeof onChange === 'function') {
          onChange(index);
        }
      });
    };

    _this.close = function () {
      if (_this.moving) {
        return false;
      }

      var onClose = _this.props.onClose;

      if (typeof onClose === 'function') {
        onClose();
      }
    };

    _this.loadOrigin = function () {
      var _this$state = _this.state,
          _this$state$currentIn = _this$state.currentIndex,
          currentIndex = _this$state$currentIn === void 0 ? 0 : _this$state$currentIn,
          images = _this$state.images;
      var _images$currentIndex = images[currentIndex],
          originUrl = _images$currentIndex.originUrl,
          loaded = _images$currentIndex.loaded;

      if (loaded !== LoadStatus.before || !originUrl) {
        return;
      }

      images[currentIndex].loaded = LoadStatus.start;

      _this.setState({
        images: images
      });

      var img = new Image();

      img.onload = function () {
        images[currentIndex].loaded = LoadStatus.end;
        images[currentIndex].url = originUrl;

        _this.setState({
          images: images
        });

        setTimeout(function () {
          images[currentIndex].loaded = LoadStatus.after;

          _this.setState({
            images: images
          });
        }, 1500);
      };

      img.src = originUrl;
    };

    _this.showOriginButton = function (images, activeIndex) {
      if (images && images[activeIndex] && images[activeIndex].originUrl // && !images[activeIndex].loaded
      ) {
          return true;
        }

      return false;
    };

    _this.onWrapperTouchStart = function () {
      _this.touchStartTime = Date.now();
    };

    _this.onWrapperTouchEnd = function () {
      var deltaTime = Date.now() - _this.touchStartTime;

      var onClose = _this.props.onClose; // prevent long tap to close component

      if (deltaTime < 300) {
        if (!_this.doubleClickTimer && !_this.moving) {
          _this.doubleClickTimer = setTimeout(function () {
            _this.doubleClickTimer = null;

            if (typeof onClose === 'function') {
              onClose();
            }
          }, 300);
        } else {
          clearTimeout(_this.doubleClickTimer);
          _this.doubleClickTimer = null;
        }
      }

      _this.moving = false;
    };

    _this.onWrapperTouchMove = function () {
      if (_this.touchStartTime) {
        _this.moving = true;
      }
    };

    _this.onWrapperMouseDown = function () {
      _this.touchStartTime = Date.now();
    };

    _this.onWrapperMouseUp = function () {
      setTimeout(function () {
        _this.moving = false;
      }, 0);
      _this.touchStartTime = 0;
    };

    _this.renderImages = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          minScale = _this$props.minScale,
          maxScale = _this$props.maxScale;
      var images = _this.state.images; // const width = document.body.offsetWidth;

      return images.map(function (item, i) {
        return React.createElement("div", {
          className: "".concat(prefixCls, "__item"),
          key: +i
        }, React.createElement(PinchZoom, {
          className: "".concat(prefixCls, "__item__img"),
          minScale: minScale,
          maxScale: maxScale
        }, React.createElement("img", {
          src: item.url,
          alt: "",
          draggable: false
        })));
      });
    };

    return _this;
  }

  _createClass(ImagePreview, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          locale = _this$props2.locale,
          activeIndex = _this$props2.activeIndex,
          showPagination = _this$props2.showPagination;
      var _this$state2 = this.state,
          _this$state2$currentI = _this$state2.currentIndex,
          currentIndex = _this$state2$currentI === void 0 ? 0 : _this$state2$currentI,
          visible = _this$state2.visible,
          images = _this$state2.images;
      var loaded = images[currentIndex].loaded;
      return React.createElement(Popup, {
        direction: "center",
        visible: visible,
        className: prefixCls
      }, React.createElement("div", {
        className: "".concat(prefixCls, "__content"),
        onTouchStart: this.onWrapperTouchStart,
        onTouchEnd: this.onWrapperTouchEnd,
        onTouchCancel: this.onWrapperTouchEnd,
        onTouchMove: this.onWrapperTouchMove,
        onMouseDown: this.onWrapperMouseDown,
        onMouseMove: this.onWrapperTouchMove,
        onMouseUp: this.onWrapperMouseUp,
        onClick: this.close
      }, React.createElement(Carousel, {
        showPagination: false,
        onChange: this.onChange,
        activeIndex: currentIndex
      }, visible ? this.renderImages() : [])), React.createElement("div", {
        className: "".concat(prefixCls, "__footer")
      }, loaded && this.showOriginButton(images, activeIndex) && loaded !== LoadStatus.after ? React.createElement("button", {
        className: "".concat(prefixCls, "__origin__button"),
        onClick: this.loadOrigin
      }, loaded === LoadStatus.start ? React.createElement(ActivityIndicator, {
        className: "".concat(prefixCls, "__loading"),
        type: "spinner"
      }) : '', locale[loaded]) : '', visible && showPagination && images && images.length > 1 && React.createElement("div", {
        className: "".concat(prefixCls, "__index")
      }, currentIndex + 1, " / ", images.length)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ('visible' in nextProps && nextProps.visible !== state.prevVisible || 'activeIndex' in nextProps && nextProps.activeIndex !== state.prevActiveIndex) {
        return {
          visible: nextProps.visible,
          activeIndex: nextProps.activeIndex,
          currentIndex: nextProps.activeIndex,
          images: formatImages(nextProps.images),
          prevVisible: nextProps.visible,
          prevActiveIndex: nextProps.activeIndex
        };
      }

      return null;
    } // shouldComponentUpdate(_nextProps, nextState) {
    //   const { images } = this.state;
    //   return isEqual(images, nextState.images);
    // }

  }]);

  return ImagePreview;
}(Component);

ImagePreview.defaultProps = {
  prefixCls: 'za-image-preview',
  activeIndex: 0,
  showPagination: true
};
export default LocaleReceiver('ImagePreview')(ImagePreview);